// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --ion-background-color: var(--planeed-color-white);
}

.content {
  display: flex;
  flex-direction: column;
  padding: 35px;
  color: var(--ion-color-text-color);
  height: 100%;
  border-radius: 10px;
}
.content span {
  font-weight: bold;
  color: var(--ion-color-text-color);
}
.content p {
  color: var(--ion-color-text-color);
}
.content .text-modal-btn {
  margin-top: auto;
  width: 100%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
